import { apiClient } from "./api";

// The activity log, across every job.
//
// Kept in its own file rather than added to applicationService: that one is
// about doing things TO an application, and this reads a report over all of
// them. `applicationService.activityTrail` remains where it is — it is a
// per-candidate read, reached from a candidate.

export const activityService = {
  /**
   * Everything that happened across every job in the store, grouped by day.
   *
   * @param {object} params
   * @param {string} [params.from]        yyyy-mm-dd, inclusive. Defaults to 13
   *                                     days ago on the server.
   * @param {string} [params.to]          yyyy-mm-dd, inclusive to end of day.
   * @param {string|number} [params.job_id]
   * @param {string|number} [params.operator_id]
   * @param {string} [params.type]        an activity_type; unknown values are
   *                                      ignored rather than returning nothing.
   *
   * The server WINDOWS this: 14 days by default, 92 maximum, and at most 800
   * entries with a `truncated` flag. That is deliberate — the activity table
   * gains a row for every action on every job, so an unbounded "show me
   * everything" is a request that works for a month and then does not.
   */
  storeLog: (params = {}) => apiClient.get("/activity", { params }),
};

export default activityService;
